import React from "react";
import { connect } from "react-redux";
import { Form, Button } from 'antd';

import "./style.css";
import LayoutWrapper from '../../layouts/LayoutWrapper';
import DynamicTable from "../../components/frame/DynamicTable";
import DynamicButton from "../../components/frame/DynamicButton";
import DynamicFilter from "../../components/frame/DynamicFilter";
import ReactAbstract from "../../components/abstract/React.abstract";
import { fetchDepartmentsList } from '../../actions/department-structure-actions';

import salaryLedgerService from "../../services/SalaryAllowance/salary-ledger-service";
class AttendanceSummary extends ReactAbstract {

    customComponentWillMount() {
        this.props.fetchDepartmentsList()
    }

    dataMode = 1
    initReload = false
    moduleName = "salaryAllowance"
    childModuleName = "attendanceSummary"

    state = {
        currentModalStatus: false,
        currentIndex: null,
        currentData: {},
        currentDataStatus: "unload",
        filters: {

        },
        data: [],
        dataStatus: "unload",
    }

    actions = {
        selectAction: salaryLedgerService.AttendanceSummary,
        // exportAction: OvertimeApprovalService.exportOvertimeApproval
    }

    headerColumn = [
        {
            title: "导出",
            access: "export_value",
            icon: "cloud-download-o",
            click: this.publicExport
        },
    ]

    filterColumn = [{
        type: "text",
        label: "请输入工号或姓名",
    },

    {
        type: "department"
    }, {
        type: "date",
        label: "结束日期",
        key: "end_date",
        format: "YYYY-MM"
    }, {
        type: "date",
        label: "开始日期",
        key: "start_date",
        format: "YYYY-MM"
    }
    ]

    tableColumn = [

        {
            title: '工号',
            dataIndex: 'job_number',
            key: 'job_number',
            className: 'table-global-head-small'
        },
        {
            title: '证件姓名',
            dataIndex: 'employee_name',
            key: 'employee_name',
            className: 'table-global-head-small',
        },
        {
            title: '年月',
            dataIndex: 'year_month',
            key: 'year_month',
            className: 'table-global-head-small',
        },
        {
            title: '实际出勤(天)',
            dataIndex: 'actual_attendance_count',
            key: 'actual_attendance_count',
            className: "table-global-head-small"
        },
        {
            title: '事假时长(小时)',
            dataIndex: 'personal_leave_count',
            key: 'personal_leave_count',
            className: "table-global-head-small"
        }, {
            title: '病假时长(小时)',
            dataIndex: 'sick_count',
            key: 'sick_count',
            className: "table-global-head-small"
        },
        {
            title: '旷工次数',
            dataIndex: 'stayaway_count',
            key: 'stayaway_count',
            className: "table-global-head-small"
        }
    ]
    privateChange = (filters, status, unreload) => this.setState({
        filters: {
            ...this.state.filters,
            ...filters,

        }
    })

    render() {
        return (
            <div className="app-module-item">
                <div className="app-module-header">
                    <div className="colAction"
                        style={{ float: "right", margin: "0px 10px 10px 0px" }}>
                        <Button type="primary" style={{ marginRight: "15px" }} onClick={this.publicSelect}>
                            <span>查询</span>
                        </Button>
                    </div>
                    <DynamicFilter column={this.filterColumn}
                        departmentsList={this.props.departmentStructure.departmentsList}
                        value={this.dataSource().filters}
                        setFilter={this.privateChange} />
                </div>
                <DynamicTable column={this.tableColumn}
                    dataStatus={this.dataSource().dataStatus}
                    dataSource={this.dataSource().data.Data}
                    pagination={{
                        total: this.dataSource().data.Total,
                        pageSize: this.dataSource().data.PageSize,
                        current: this.dataSource().filters.page
                    }}
                    setPageFilter={this.publicChange}
                />
            </div>
        )
    }
}



const mapStateToProps = state => {
    return {
        departmentStructure: state.departmentStructure
    }
}

const mapDispatchToProps = {
    fetchDepartmentsList
}

AttendanceSummary = Form.create()(connect(mapStateToProps, mapDispatchToProps)(AttendanceSummary));

export default LayoutWrapper(AttendanceSummary);


// WEBPACK FOOTER //
// ./src/routes/SalaryAllowance/AttendanceSummary.js